import { inject, Injectable } from '@angular/core';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { Subject } from 'rxjs';
import moment from 'moment';
import { PrimeNG } from 'primeng/config';
import { TranslateService } from '@ngx-translate/core';
import { LOCALES, momentLocaleMap, SUPPORTED_LANGUAGES } from '../../config/locale.config';
import { GeneralUtilsService } from './common/generalUtils.service';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  //Services
  private generalUtilsService = inject(GeneralUtilsService);
  private primeng = inject(PrimeNG);
  private translateService = inject(TranslateService);

  private currentLocale: string;
  public localeChange: Subject<string> = new Subject<string>();

  private defaultPrimeNgTranslation = null;
  constructor() {
    LOCALES.forEach(({ code, locale }) => {
      defineLocale(code, locale);
    });
    this.setLocale('en');
    moment.locale(momentLocaleMap['en']);

    // Set default PrimeNG translation
    this.defaultPrimeNgTranslation = this.primeng.translation;
  }

  setLocale(locale: string) {
    this.currentLocale = locale;
    // moment
    moment.locale(momentLocaleMap[locale] || locale);

    this.translateService.get('primeng').subscribe((res) => {
      // As fallback we use the default PrimeNG translation to fill the missing keys from our override
      const merged = this.generalUtilsService.deepMerge({ ...this.defaultPrimeNgTranslation }, res);

      // Update PrimeNG translation
      this.primeng.setTranslation({
        ...merged,
        dayNames: moment.localeData().weekdays(),
        dayNamesShort: moment.localeData().weekdaysShort(),
        dayNamesMin: moment.localeData().weekdaysMin(),
        monthNames: moment.localeData().months(),
        monthNamesShort: moment.localeData().monthsShort(),
        dateFormat: 'dd/mm/yy',
      });
    });

    this.localeChange.next(locale);
  }

  getCurrentLocale(): string {
    return this.currentLocale;
  }

  getAvailableLocales(): string[] {
    return SUPPORTED_LANGUAGES;
  }
}
